import { ratesLabels } from 'axl-config';
const updateInputValueHelper = function (inputData) {
  if (inputData === void 0) {
    inputData = {};
  }
  const {
    inputName,
    inputValue,
    category
  } = inputData;
  if (category === 'deal') {
    return {
      ...(inputName === 'downPaymentInput' || inputName === 'dueAtSigning' ? {
        downPayment: inputValue?.slice(1)?.toString()?.replace(',', '')
      } : {}),
      ...(inputName === 'creditTierInput' && {
        creditRating: `${ratesLabels[inputValue]?.label} ${ratesLabels[inputValue]?.subLabel}`
      }),
      ...((inputName === 'termInput' || inputName === 'leaseTermInput') && {
        termLength: inputValue?.toString()
      }),
      ...(inputName === 'offerPriceInput' ? {
        offerPrice: inputValue?.slice(1)?.toString()?.replace(',', '')
      } : {})
    };
  }
  if (category === 'tradeIn') {
    return {
      ...(inputName === 'tradeInInput' ? {
        valuation: inputValue?.slice(1)?.toString()?.replace(',', '')
      } : {}),
      ...(inputName === 'amountOwedInput' ? {
        payoff: inputValue?.slice(1)?.toString()?.replace(',', '')
      } : {})
    };
  }
  return {};
};
export default updateInputValueHelper;